import axios from "axios";
import { api } from "../Configurations/axios";
import { ProjectGroupingModel } from "../Models/ProjectGroupingModel";

const getAllGroupingPaginatedByCompanyIdAPI = async (companyId: string, page: number, take: number, word: string, year: string) => {
    try {
        var result = await api.get(`/ProjectGrouping/GetAllPaginatedByCompanyId/companyId=${companyId}&page=${page}&take=${take}&word=${encodeURIComponent(word)}&year=${year}`);
        var response = result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const getGroupingByIdAPI = async (groupingId: string) => {
    try {
        var result = await api.get(`/ProjectGrouping/GetGroupingNameById/groupingId=${groupingId}`);
        var response = result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const createProjectGroupingAPI = async (companyId: string, groupingNumber: number, groupingName: string, year: number) => {
    try {
        var result = await api.post('/ProjectGrouping/CreateProjectGrouping', { groupNumber: groupingNumber, name: groupingName, companyId: companyId, year: year });
        var response = result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const deleteGroupingByIdAPI = async (id: string, companyId: string) => {
    try {
        var data = { groupingId: id, companyId: companyId };
        var result = await api.delete('/ProjectGrouping/DeleteGroupingById', { data });
        var response = result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}
const handleDownloadProjectGroupingModelAPI = async (companyId: string) => {
    try {
       
        const result = await api.get(`/ProjectGrouping/DownloadGrouping/companyId=${companyId}`, {
            responseType: 'blob'
        });
        const response = await result.data;
        return response;
    }
    catch (error: any) {
        throw new Error(error.response.data);
    }
}
const handleUploadProjecGroupingtAPI = async (file: Blob, companyId:  string, userEmail: string) => {
    try {
        var UploadProjectFileCommand = new FormData()

        UploadProjectFileCommand.append('file', file);
        UploadProjectFileCommand.append('companyId', companyId);
        UploadProjectFileCommand.append('userEmail', userEmail);

        var result = await api.post(`/ProjectGrouping/UploadExcel`, UploadProjectFileCommand, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }

        });
        const dataFiles = await result.data;
        return dataFiles;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const AddJustificationProjectGroupingAPI = async (projectGroupingId: string, justification: string, userEmail: string, companyId: string) => {
    try {
        const result = await api.put('/ProjectGrouping/AddJustificationProjectGrouping', { projectGroupingId: projectGroupingId, justification: justification, userEmail: userEmail, companyId: companyId });
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

export {
    getAllGroupingPaginatedByCompanyIdAPI,
    getGroupingByIdAPI,
    createProjectGroupingAPI,
    handleDownloadProjectGroupingModelAPI,
    handleUploadProjecGroupingtAPI,
    deleteGroupingByIdAPI,
    AddJustificationProjectGroupingAPI
}